import React, { Component } from 'react';
import {
  Modal,
  Panel,
  Button,
  Table
}                              from "react-bootstrap";
import JSONPretty from 'react-json-pretty';
import moment from 'moment';

import CrudComponent           from "../zynappse-crud/index.js";
import schema from "./PointsWalletAPILogs_schema.js";
import { IS_VALID } from 'utils';

class PointsWalletAPILogs extends Component {
  constructor (props) {
    super(props);

    this.state = {
      showModal: false,
      selectedData: null
    };
  }

  render () {
    const {
      showModal,
      selectedData
    } = this.state;

    const crudProps = {
      schema,
      moduleQuery: [
        { method: "descending", column: "createdAt" }
      ],
      customView: (item) => {
        this.setState({
          showModal: true,
          selectedData: item
        });
      }
    };
    
    return (
      <div>
        <Panel>
          <Panel.Heading style={{
            backgroundColor: '#D1282F',
            color: 'white'
          }}>
            <h4>Points Wallet API Logs</h4>
          </Panel.Heading>
          <Panel.Body>
            <CrudComponent {...crudProps}/>
          </Panel.Body>
        </Panel>
        <Modal
            show={showModal}
            onHide={() => {
              this.setState({
                showModal: false,
                selectedData: null
              });
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title>VIEW</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <View
                {...{
                  selectedData
                }}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                  onClick={() => {
                    this.setState({
                      showModal: false,
                      selectedData: null
                  });
                }}
              >
                CLOSE
              </Button>
            </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

class View extends Component {
  render () {
    const {
      selectedData
    } = this.props;''

    const GET_VALUE = (key) => {
      if (
          IS_VALID(selectedData) &&
          IS_VALID(selectedData.get(key))
      ) {
          let value = "";

          if (
              key === "createdAt" ||
              key === "updatedAt"
          ) {
              value = moment(selectedData.get(key)).format("MM/DD/YYYY hh:mm:ss A");
          } else if (key === "params" || key === "response_data") {
              value = selectedData.get(key) ? <JSONPretty id={key} data={selectedData.get(key) }/> : ''
          } else {
              value = selectedData.get(key);
          }

          return value;
      } else {
          return "";
      }
    }

    let data = [
      {
        label: "Member ID",
        value: GET_VALUE("memberId")
      },
      {
        label: "Status",
        value: GET_VALUE("status")
      },
      {
        label: "Error Code",
        value: GET_VALUE("errorCode")
      },
      {
        label: "Error Stack",
        value: GET_VALUE("errorStack")
      },
      {
        label: "Error Message",
        value: GET_VALUE("errorMessage")
      },
      {
        label: "Error Response",
        value: GET_VALUE("errorResponse")
      },
      {
        label: "Date",
        value: GET_VALUE('createdAt')
      }
    ];

    return (
      <Table
        bordered
        responsive
      >
        <tbody>
          {data.map((item, index) => (
            <tr id={index}>
              <td>
                <b>{item.label}</b>
              </td>
              <td>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }
}
export default PointsWalletAPILogs;


// WEBPACK FOOTER //
// ./components/Logs/PointsWalletAPILogs.js